import React, { Component } from "react";
import "./MyAccountSideBar.scss";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import profilemen from "../../common/images/profile_men.svg";
import profilewishlist from "../../common/images/profile_wish.svg";
import cookie from "react-cookies";
import profilebooking from "../../common/images/profile_book.svg";
import profilecalcel from "../../common/images/profile_cancel.svg";
import logout from "../../common/images/log-out.svg";
import Avatar from "react-avatar";
import ModalPopup from "../../common/components/ModalPopup/ModalPopup";
import { handleApiCall, handleMediaApiCall } from "../Helpers/apiHelper";
import AlertPopup from "../../common/components/AlertPopup/AlertPopup";
import ContentLoader from "react-content-loader";
import ProfileDiabledIcon from "../../common/images/my-account-user-disabled-icon.svg";
import WishlistDisbledIcon from "../../common/images/my-account-wishlists-disabled-icon.svg";
import BookingsDisabledIcon from "../../common/images/my-account-bookings-disabled-icon.svg";
import CancellationDisabledIcon from "../../common/images/my-account-cancellations-disabled-icon.svg";
import SettingsDisabledIcon from "../../common/images/my-account-setting-disabled-icon.svg";
import ProfileEnabledIcon from "../../common/images/my-account-user-enabled-icon.svg";
import WishlistEnabledIcon from "../../common/images/my-account-wishlists-enabled-icon.svg";
import BookingsEnabledIcon from "../../common/images/my-account-bookings-enabled-icon.svg";
import CancellationEnabledIcon from "../../common/images/my-account-cancellations-disabled-icon.svg";
import SettingsEnabledIcon from "../../common/images/my-account-setting-enabled-icon.svg";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    const {
      activePage,
      setActivePage,
      customerDetails,
      handleGetCustomerDetails,
      isMobile,
      isLoading,
    } = this.props;
    this.state = {
      activePage: activePage || "",
      isMobile: isMobile || false,
      showLogoutPoppup: false,
      openAlertPopup: false,
      popupTitle: "",
      alertPopupMsg: "",
      isUploading: false,
    };
    this.fileInputRef = React.createRef();
    this.inactivityTimeout = null;
    this.resetLogoutTimeout();
    this.setActivePage = setActivePage;
    this.handleGetCustomerDetails = handleGetCustomerDetails;
    this.isLoading = isLoading;
  }

  componentWillReceiveProps(PropsData) {
    if (PropsData.activePage !== this.state.activePage) {
      this.setState({ activePage: PropsData.activePage });
    }
  }

  handleConfirmLogout = () => {
    try {
      cookie.remove("UserId", { path: "/logout" });
      this.setState({ showLogoutPoppup: false });
      this.props.history.push("/logout");
    } catch (err) {
      console.log(err);
    }
  };
  autoLogout = () => {
    cookie.remove("UserId", { path: "/" });
    this.props.history.push("/");
  };
  handleUserActivity = () => {
    this.resetLogoutTimeout();
  };
  resetLogoutTimeout = () => {
    clearTimeout(this.inactivityTimeout);
    this.inactivityTimeout = setTimeout(this.autoLogout, 3 * 60 * 60 * 1000);
  };
  componentDidMount() {
    window.addEventListener("mousemove", this.handleUserActivity);
    window.addEventListener("keydown", this.handleUserActivity);
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this.handleUserActivity);
    window.removeEventListener("keydown", this.handleUserActivity);
    clearTimeout(this.inactivityTimeout);
  }

  showAlert = (title, message) => {
    this.setState({
      openAlertPopup: true,
      popupTitle: title,
      alertPopupMsg: message,
    });
  };

  uploadFiles = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    const response = await this.handleUploadImage(formData);
    if (response?.status === "ok") {
      // Clear file input using ref
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = "";
      }
    }
  };

  handleUploadImage = async (formData) => {
    try {
      this.setState({ isUploading: true });

      const mediaRes = await handleMediaApiCall(
        "post",
        "image/upload",
        formData
      );
      if (mediaRes.data.status !== "ok") {
        this.showAlert("Error", "Image upload failed.");
        return;
      }

      const { web: imageUrl } = mediaRes.data;
      const userId = cookie.load("UserId");

      const profileForm = new FormData();
      profileForm.append("customer_photo", imageUrl);
      profileForm.append("customer_id", userId);

      const profileRes = await handleApiCall(
        "post",
        "customer/updateprofileimage",
        profileForm
      );

      if (profileRes.data.status === "ok") {
        this.setState({ imageurl: profileRes.data.url });
        this.showAlert("Success", profileRes.data.message);

        if (userId) {
          const params = "customer_id=" + userId;
          this.handleGetCustomerDetails(params);
        }
      } else {
        const errorMsg = profileRes.data.form_error || profileRes.data.message;
        this.showAlert("Error", errorMsg);
      }

      return profileRes.data;
    } catch (error) {
      console.error("Upload error:", error);
      this.showAlert(
        "Error",
        "An unexpected error occurred while uploading the image."
      );
    } finally {
      this.setState({ isUploading: false });
    }
  };

  render() {
    const loading = this.state.isUploading || this.isLoading;
    return (
      <>
        <section className="side-bar-main">
          {this.state.isMobile && (
            <div className="side-bar-main__title">
              <h3>My Account</h3>
            </div>
          )}
          {loading ? (
            <ContentLoader
              viewBox="0 0 100 100"
              width="100%"
              height="100%"
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
            >
              <circle cx="50" cy="30" r="15" />
              <rect x="5" y="50" rx="4" ry="4" width="90" height="10" />
              <rect x="5" y="64" rx="4" ry="4" width="90" height="7" />
              <rect x="5" y="75" rx="8" ry="8" width="90" height="15" />
            </ContentLoader>
          ) : (
            <div className="side-bar-main__avatar-cntnr">
              <div className="side-bar-main__avatar-cntnr__user-avatar">
                {this.props.customerDetails?.customer_photo ? (
                  <img
                    src={this.props.customerDetails?.customer_photo}
                    alt="ProfileImage"
                  />
                ) : (
                  <Avatar
                    name={this.props.customerDetails?.customer_name}
                    size="150"
                    round={true}
                    color="#4258bf"
                  />
                )}
                <div className="side-bar-main__avatar-cntnr__user-avatar__edit-camera">
                  <form action="#" method="post" encType="multipart/form-data">
                    <input
                      type="file"
                      id="profile_image"
                      className="custom-file-input"
                      onChange={this.uploadFiles}
                      ref={this.fileInputRef}
                    />
                  </form>
                </div>
              </div>
              <h3 className="side-bar-main__avatar-cntnr__user-name">
                {this.props.customerDetails?.customer_name}
              </h3>
              <p className="side-bar-main__avatar-cntnr__user-info">
                Traveller
                <span></span>
                {this.props.customerDetails?.customer_email}
              </p>
              <button
                className="side-bar-main__avatar-cntnr__user-edit-btn"
                onClick={() => this.setActivePage("profile")}
              >
                Edit Profile
              </button>
            </div>
          )}
          <ul className="side-bar-main__menu-cntnr">
            <li className={this.state.activePage === "profile" ? "active" : ""}>
              <button
                className="pronav"
                onClick={() => this.setActivePage("profile")}
              >
                <img
                  className="normal-img"
                  src={
                    this.state.activePage === "profile"
                      ? ProfileEnabledIcon
                      : ProfileDiabledIcon
                  }
                  alt="profilemenblue"
                />
                <span>My profile</span>
              </button>
            </li>
            <li className={this.state.activePage === "mytrips" ? "active" : ""}>
              <button
                className="pro-wish"
                onClick={() => this.setActivePage("mytrips")}
              >
                <img
                  className="normal-img"
                  src={
                    this.state.activePage === "mytrips"
                      ? WishlistEnabledIcon
                      : WishlistDisbledIcon
                  }
                  alt="profilewish"
                />
                <span>My trips</span>
              </button>
            </li>
            <li
              className={this.state.activePage === "mybookings" ? "active" : ""}
            >
              <button
                className="probook"
                onClick={() => this.setActivePage("mybookings")}
              >
                <img
                  className="normal-img"
                  src={
                    this.state.activePage === "mybookings"
                      ? BookingsEnabledIcon
                      : BookingsDisabledIcon
                  }
                  alt="profile_book"
                />
                <span>my bookings</span>
              </button>
            </li>
            <li
              className={
                this.state.activePage === "cancellation" ? "active" : ""
              }
            >
              <button
                className="procancel"
                onClick={() => this.setActivePage("cancellation")}
              >
                <img
                  className="normal-img"
                  src={
                    this.state.activePage === "cancellation"
                      ? CancellationEnabledIcon
                      : CancellationDisabledIcon
                  }
                  alt="profilecancel"
                />
                <span>Cancellations</span>
              </button>
            </li>
            <li
              className={this.state.activePage === "settings" ? "active" : ""}
            >
              <button
                className="procancel"
                onClick={() => this.setActivePage("settings")}
              >
                <img
                  className="normal-img"
                  src={
                    this.state.activePage === "settings"
                      ? SettingsEnabledIcon
                      : SettingsDisabledIcon
                  }
                  alt="profilecancel"
                />
                <span>Settings</span>
              </button>
            </li>
            <li>
              <button
                className="procancel"
                onClick={() => this.setState({ showLogoutPoppup: true })}
              >
                <img className="normal-img" src={logout} alt="logout" />
                <span>Logout</span>
              </button>
            </li>
          </ul>
        </section>
        <ModalPopup
          open={this.state.showLogoutPoppup}
          handleClose={() => this.setState({ showLogoutPoppup: false })}
        >
          <div className="logout-popup-cntnr">
            <h3>Are you sure want to logout </h3>
            <div className="logout-popup-action">
              <button
                className="btn--primary"
                onClick={this.handleConfirmLogout}
              >
                Yes
              </button>
              <button
                className="btn--secondary"
                onClick={this.resetLogoutTimeout}
              >
                No
              </button>
            </div>
          </div>
        </ModalPopup>
        <AlertPopup
          open={this.state.openAlertPopup}
          handleClose={() => this.setState({ openAlertPopup: false })}
          title={this.state.popupTitle}
          message={this.state.alertPopupMsg}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

Sidebar.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
